import { Link } from 'react-router-dom';
import { getTrendingArticles } from '@/mocks/articles';
import { categoryMap } from '@/mocks/categories';
import ArticleCard from '@/components/feature/ArticleCard';

export default function TrendingSection() {
  const trendingArticles = getTrendingArticles().slice(0, 4);

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <span className="w-2 h-6 bg-accent-500 rounded-full" />
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              实时热点
            </h2>
          </div>
          <Link
            to="/category/zixun"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            查看更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {trendingArticles.map((article, index) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              excerpt={article.excerpt}
              coverImage={article.coverImage}
              categoryId={article.categoryId}
              categoryName={categoryMap[article.categoryId]?.name || ''}
              author={article.author}
              publishedAt={article.publishedAt}
              viewCount={article.viewCount}
              isHot={article.isHot}
              size={index === 0 ? 'large' : 'default'}
            />
          ))}
        </div>
      </div>
    </section>
  );
}